import { makeAutoObservable, runInAction } from 'mobx';
import { WS_API_BASE_URL } from '../utils/consts';

export default class WebSocketStore {
    constructor() {
        this._indicatorUpdate = {
            id: 0,
            patient: 0, // ID пациента, для которого это обновление
            pulse: 0,
            respiratory_rate: 0,
            saturation: 0,
            oxygen_flow: 0,
            timestamp: '',
        };
        this._spo2Update = {
            therapy_id: 0,
            patient_id: 0,
            spO2_value: 0,
        };
        this._webSocket = null;
        makeAutoObservable(this);
    }

    setIndicatorUpdate(indicatorUpdate) {
        this._indicatorUpdate = indicatorUpdate;
    }
    setSpo2Update(spo2Update) {
        this._spo2Update = spo2Update;
    }
    setWebSocket(webSocket) {
        this._webSocket = webSocket;
    }
    get indicatorUpdate() {
        return this._indicatorUpdate;
    }
    get spo2Update() {
        return this._spo2Update;
    }
    get webSocket() {
        return this._webSocket;
    }

    async connect() {
        const token = localStorage.getItem('access_token');

        // Если прошла авторизация и есть токен, устанавливаем WebSocket соединение
        if (token) {
            this.setWebSocket(
                new WebSocket(`${WS_API_BASE_URL}doctor/indicators/?token=${token}`)
            );

            this.webSocket.onopen = () => {
                console.log('WebSocket подключен ко всем обновлениям врача', this._webSocket);
            };

            this.webSocket.onmessage = (event) => {
                const eventData = JSON.parse(event.data);
                const data = eventData.data;
                if (eventData.type === 'indicator_update') {
                    // сохраняем plain object, не proxy/getter
                    runInAction(() => {
                        this.setIndicatorUpdate({
                            id: data.id,
                            patient: data.patient,
                            pulse: data.pulse,
                            respiratory_rate: data.respiratory_rate,
                            saturation: data.saturation,
                            oxygen_flow: data.oxygen_flow,
                            timestamp: data.timestamp,
                        });
                    });
                    // console.log('Новый показатель пациента:', this._indicatorUpdate);
                } else if (eventData.type === 'spo2_update') {
                    // сохраняем plain object, не proxy/getter
                    runInAction(() => {
                        this.setSpo2Update({
                            therapy_id: data.therapy_id,
                            patient_id: data.patient_id,
                            spO2_value: data.spO2_value,
                        });
                    });
                    // console.log('Обновление SpO2 в терапии:', this._spo2Update);
                }
            };

            this.webSocket.onerror = (error) => {
                console.error('WebSocket ошибка:', error);
            };

            this.webSocket.onclose = (event) => {
                console.log('WebSocket отключен:', event.code, event.reason);
            };
        }
    }
    async close() {
        this._webSocket.close();
        console.log(this._webSocket);
    }
}

// ### 2. Все обновления для врача (рекомендуется)
// **URL:** `/ws/doctor/indicators/?token=<jwt_token>`

// **Описание:** Подключение к WebSocket для получения всех обновлений, связанных с врачом:
// - Обновления показателей всех пациентов врача (пульс, ЧДД, сатурация, расход кислорода)
// - Обновления `spO2_value` во всех терапиях, назначенных врачом

// Врач определяется автоматически из JWT токена, затем находятся все пациенты и терапии. Подключение автоматически подписывается на все соответствующие группы.

// **Преимущества:**
// - Один WebSocket для всех обновлений врача
// - Автоматическое определение врача из JWT токена
// - Автоматическое определение пациентов и терапий из базы данных
// - Не нужно знать ID пациентов или терапий заранее
// - Получает оба типа обновлений в одном потоке
// - Работает даже если у врача пока нет пациентов или терапий (будет получать обновления, когда появятся)

// **Когда отправляется:**
// - **indicator_update**: При создании нового показателя для любого из пациентов врача через `POST /api/patients/{id}/indicators/`
// - **spo2_update**: При обновлении поля `spO2_value` в любой терапии, назначенной врачом, через `PATCH /api/therapies/{id}/` или `PUT /api/therapies/{id}/`
